export const GET_BLOGS = "GET_BLOGS"
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS"
export const GET_BLOGS_FAIL = "GET_BLOGS_FAIL"

export const GET_BLOG_DETAILS = "GET_BLOG_DETAILS"
export const GET_BLOG_DETAILS_SUCCESS = "GET_BLOG_DETAILS_SUCCESS"
export const GET_BLOG_DETAILS_FAIL = "GET_BLOG_DETAILS_FAIL"
